import template from './active.html';
import controller from './active.controller';

const activeComponent = {
  template,
  controller,
  controllerAs: 'active'
};

export default activeComponent;


/** WEBPACK FOOTER **
 ** ./frontend/components/active/active.component.js
 **/